import { Component, OnInit, ViewEncapsulation, inject, signal } from '@angular/core';
import { SessionService } from 'account-hybrid/core/authentication';
import { SpacesService } from 'account-hybrid/common/components/spaces';
import { NavModule } from 'account-hybrid/common/components/navigation/navigation.module';
import { HeaderModule } from 'account-hybrid/common/components/header/header.module';
import { LegacyShimsModule } from '../../../account-shared/legacy-shims/legacy-shims.module';
import { CooperativeBigPictureComponent } from './cooperative-big-picture.component';
import { CooperativeRoadmapComponent } from './cooperative-roadmap.component';
import { CooperativePartnersComponent } from './cooperative-partners.component';

interface CoopSection {
    name: string;
    title: string;
    isActive: boolean;
    isDisabled: boolean;
}

/**
 * Cooperative state shell: renders the main nav, the cooperative header hero
 * (company properties from SessionService/SpacesService), and the 3-tab
 * `<ft-sections>` nav hosting the big-picture / roadmap / partners sections.
 */
@Component({
    selector: 'ft-cooperative-ng',
    imports: [
        NavModule,
        HeaderModule,
        LegacyShimsModule,
        CooperativeBigPictureComponent,
        CooperativeRoadmapComponent,
        CooperativePartnersComponent,
    ],
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./cooperative.component.scss'],
    templateUrl: './cooperative.component.html',
})
export class CooperativeComponent implements OnInit {
    protected readonly properties = signal<any[]>([]);

    // Native round-trip drain: SessionService/SpacesService were grabbed via the
    // $injector bridge in ngOnInit; resolved here via field initializers (a valid
    // injection context — inject() in ngOnInit would throw NG0203). No bridge remains.
    private readonly sessionService = inject(SessionService);
    private readonly spacesService = inject(SpacesService);

    protected readonly sections: CoopSection[] = [
        { name: 'big picture', title: 'The Big Picture', isActive: true, isDisabled: false },
        { name: 'roadmap', title: 'Roadmap', isActive: false, isDisabled: false },
        { name: 'partners', title: 'Partnerships', isActive: false, isDisabled: false },
    ];

    ngOnInit(): void {
        const company = this.sessionService.getCompany(this.spacesService.getCompanyUuid());
        this.properties.set(company ? this.sessionService.getCompanyProperties(company.UUID) : []);
    }
}
